module.exports = __webpack_public_path__ + "static_portal/img/9.ef81c6b2.jpg";